export default {"src":"/_next/static/media/seller-guide.05aa08ab.svg","height":502,"width":708,"blurWidth":0,"blurHeight":0};